<template>
    <div class="common-flexbox supplementalRegisterContainer">
        <VeeForm class="form-container" @submit="submitAdditionalDetails" :initial-values="initialFormValues">
            <div class="container"
                v-if="conferenceCallDetails.AskForPublicPrivate && isPublicParticipantDeclared === null && !currentUserIsPresenter">
                <div class="heading declaration-heading align-left">{{ $t('supplemental_register.declaration') }}</div>
                <div class="gutter-bottom-15 align-left">
                    <VeeField name="callTypeDeclaration" :rules="decRules" v-slot="{ handleChange, handleBlur, errors }">
                        <div>
                            <label class="radio-label">
                                <input type="radio" id="publicCall" value="true" v-model="publicSelected"
                                    @change="handleChange('true'); updateField('callTypeDeclaration', 'true')"
                                    @blur="(event) => { fieldBlurred.callTypeDeclaration = true; handleBlur(event); }">
                                <div class="radio-div">
                                    <span>{{ $t('supplemental_register.public') }}</span>
                                </div>
                            </label>
                            <label class="radio-label">
                                <input type="radio" id="privateCall" value="false" v-model="publicSelected"
                                    @change="handleChange('false'); updateField('callTypeDeclaration', 'false')"
                                    @blur="(event) => { fieldBlurred.callTypeDeclaration = true; handleBlur(event); }">
                                <div class="radio-div">
                                    <span>{{ $t('supplemental_register.private') }}</span>
                                </div>
                            </label>
                        </div>
                        <div v-if="fieldBlurred.callTypeDeclaration && errors.length" class="align-left error-message">{{
                            getErrorMessage('Declaration', errors[0]) }}</div>
                    </VeeField>
                    <div class="gutter-bottom-15 private-call-information">
                        {{ $t('supplemental_register.private_call_info') }}
                    </div>
                </div>
            </div>
            <div v-if="hasFormFields" class="heading form-fields-heading align-left">
                {{ $t('supplemental_register.form_fields_head') }}</div>
            <div class="container" v-if="hasField('SalesRep')">
                <div class="input-container margin-bt-10">
                    <VeeField name="salesRepName" :rules="registrationFields.SalesRep.rules"
                        v-slot="{ field, errors, handleChange, handleBlur }">
                        <InputBox v-if="hasField('SalesRep')" :field="field" id="salesRepName" class="email-input"
                            name="salesRepName" type="text" :label="registrationPlaceholder || ''"
                            :data-vv-as="registrationLabel || ''" :regFlowLogin="true"
                            :modelValue="registrationFields.SalesRep.value" :rules="registrationFields.SalesRep.rules"
                            @update="(value) => { handleSalesRepChange(value); handleChange(value); }"
                            @blur="(event) => { fieldBlurred.salesRepName = true; handleBlur(event); }" />
                        <div v-show="hasField('SalesRep') && hasOptionalFields
                            && !errors.length" class="optional-label"
                            :style="registrationFields.SalesRep.data.Required ? 'opacity:0' : ''">{{ $t(optionalText) }}
                        </div>
                        <div v-if="fieldBlurred.salesRepName && errors.length" class="align-left error-message">{{
                            getErrorMessage(registrationPlaceholder, errors[0]) }}</div>
                    </VeeField>
                </div>
            </div>
            <div class="container" v-if="hasField('CCInvite')">
                <div class="input-container margin-bt-10">
                    <VeeField name="ccInvite" :rules="registrationFields.CCInvite.rules"
                        v-slot="{ field, errors, handleChange, handleBlur }">
                        <InputBox v-if="hasField('CCInvite')" :field="field" id="ccInvite"
                            class="email-input align-left" name="ccInvite" type="text"
                            :label="ccInvitePlaceholder || ''" :data-vv-as="ccInviteLabel || ''" :regFlowLogin="true"
                            :tooltipEnabled="true" :tooltipOptions="ccInviteToolTip"
                            :modelValue="registrationFields.CCInvite.value"
                            @update="(value) => { handleCCInviteChange(value); handleChange(value); }"
                            @blur="(event) => { fieldBlurred.ccInvite = true; handleBlur(event); }"
                            :rules="registrationFields.CCInvite.rules" />
                        <div v-show="hasField('CCInvite') && hasOptionalFields
                            && !errors.length && isValidEmail" class="optional-label"
                            :style="registrationFields.CCInvite.data.Required ? 'opacity:0' : ''">{{ $t(optionalText) }}
                        </div>
                        <div v-if="fieldBlurred.ccInvite && errors.length" class="align-left error-message">{{
                            getErrorMessage(ccInvitePlaceholder, errors[0]) }} </div>
                    </VeeField>
                </div>
            </div>
            <div class="container" v-if="hasField('CityLocation')">
                <div class="input-container margin-bt-10">
                    <VeeField name="cityLocation" :rules="registrationFields.CityLocation.rules"
                        v-slot="{ field, errors, handleChange, handleBlur }">
                        <InputBox v-if="hasField('CityLocation')" :field="field" id="cityLocation"
                            class="email-input align-left" name="cityLocation" type="text"
                            :label="cityLocationPlaceholder || ''" :data-vv-as="cityLocationLabel || ''"
                            :regFlowLogin="true" :tooltipEnabled="true" :tooltipOptions="cityLocationToolTip"
                            :modelValue="registrationFields.CityLocation.value"
                            @update="(value) => { handleCityLocationChange(value); handleChange(value); }"
                            @blur="(event) => { fieldBlurred.cityLocation = true; handleBlur(event); }"
                            :rules="registrationFields.CityLocation.rules" />
                        <div v-show="hasField('CityLocation') && hasOptionalFields
                            && !errors.length" class="optional-label"
                            :style="registrationFields.CityLocation.data.Required ? 'opacity:0' : ''">
                            {{ $t(optionalText) }}</div>
                        <div v-if="fieldBlurred.cityLocation && errors.length" class="align-left error-message">{{
                            getErrorMessage(cityLocationPlaceholder, errors[0]) }}</div>
                    </VeeField>
                </div>
            </div>
            <div class="container" v-if="hasField('JoinPreference')">
                <div class="input-container margin-bt-10">
                    <VeeField name="joinPreference" :rules="registrationFields.JoinPreference.rules"
                        v-slot="{ field, errors, handleChange, handleBlur }">
                        <CustomDropDown :field="field" :modelValue="registrationFields.JoinPreference.value"
                            id="joinPreference" class="email-input" :options="joinPreferencesOption"
                            :regFlowLogin="true" :placeHolderValue="joinPreferencesPlaceholder || ''"
                            :data-vv-as="joinPreferencesLabel || ''" optionKey="label" optionValue="value"
                            name="joinPreference" :rules="registrationFields.JoinPreference.rules"
                            v-if="hasField('JoinPreference')"
                            @change="(value) => { onJoinPreferenceChange(value); handleChange(value); }"
                            @blur="(event) => { fieldBlurred.joinPreference = true; handleBlur(event); }" />
                        <div v-show="hasField('JoinPreference') && hasOptionalFields
                            && !errors.length" class="optional-label"
                            :style="registrationFields.JoinPreference.data.Required ? 'opacity:0' : ''">
                            {{ $t(optionalText) }}</div>
                        <div v-if="fieldBlurred.joinPreference && errors.length" class="align-left error-message">{{
                            getErrorMessage(joinPreferencesLabel, errors[0]) }}</div>
                    </VeeField>
                </div>
            </div>
            <div class="container" v-if="hasField('DailInLocation')">
                <div class="input-container margin-bt-10">
                    <VeeField :name="'dailInLocation'" :rules="registrationFields.DailInLocation.rules"
                        v-slot="{ field, errors, handleChange, handleBlur }">
                        <CustomDropDown :field="field" :value="registrationFields.DailInLocation.value"
                            v-model="registrationFields.DailInLocation.value" id="dailInLocation" class="email-input"
                            :options="countries" :regFlowLogin="true" :tooltipEnabled="true"
                            :tooltipOptions="dailInToolTip" :placeHolderValue="dailInLocationPlaceholder || ''"
                            :data-vv-as="dailInLocationLabel || ''" optionKey="Id" optionValue="Name" name="country"
                            :rules="registrationFields.DailInLocation.rules" v-if="hasField('DailInLocation')"
                            @change="(value) => { onDailInLocationChange(value); handleChange(value); }"
                            @blur="(event) => { fieldBlurred.dailInLocation = true; handleBlur(event); }" />
                        <div v-show="hasField('DailInLocation') && hasOptionalFields
                            && !errors.length" class="optional-label"
                            :style="registrationFields.DailInLocation.data.Required ? 'opacity:0' : ''">
                            {{ $t(optionalText) }}</div>
                        <div v-if="fieldBlurred.dailInLocation && errors.length" class="align-left error-message">{{
                            getErrorMessage(dailInLocationLabel, errors[0]) }}</div>
                    </VeeField>
                </div>
            </div>
            <div class="container" v-if="hasField('StaffNumber')">
                <div class="input-container margin-bt-10">
                    <VeeField :name="'staffNumber'" :rules="registrationFields.StaffNumber.rules"
                        v-slot="{ field, errors, handleChange, handleBlur }">
                        <InputBox v-if="hasField('StaffNumber')" :field="field" id="staffNumber" class="email-input"
                            name="staffNumber" type="text" :modelValue="registrationFields.StaffNumber.value"
                            :label="staffNumberPlaceholder || ''" :data-vv-as="staffNumberLabel || ''"
                            :regFlowLogin="true"
                            @update="(value) => { handleStaffNumberChange(value); handleChange(value); }"
                            @blur="(event) => { fieldBlurred.staffNumber = true; handleBlur(event); }"
                            :rules="registrationFields.StaffNumber.rules" />
                        <div v-show="hasField('StaffNumber') && hasOptionalFields
                            && !errors.length" class="optional-label"
                            :style="registrationFields.StaffNumber.data.Required ? 'opacity:0' : ''">
                            {{ $t(optionalText) }}</div>
                        <div v-if="fieldBlurred.staffNumber && errors.length" class="align-left error-message">{{
                            getErrorMessage(staffNumberPlaceholder, errors[0]) }}</div>
                    </VeeField>
                </div>
            </div>
            <div class="container" v-if="hasAdditionalIns !== -1">
                <div class="gutter-bottom-15 private-call-information">
                    <pre>{{ brandingData.CustomMessages[hasAdditionalIns].Value }}</pre>
                </div>
            </div>
            <div class="common-flexbox flex-content-align-left button-container">
                <button id="submitDeclerationButton" type="submit" class="common-button gutter-top-20"
                    :disabled="!isComplete">{{ continueButtonText }}</button>
            </div>
        </VeeForm>
    </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';

import { InputBox } from '@/components/ui/Form';
import Constants from '@/utils/constants';
import CustomDropDown from '@/components/common/CustomDropDown/MaterialCustomDropDown.vue';
import {
    confirmEmailDomain
} from "@/service/api";

// Import composables
import { 
    usePresentation,
    useCorporateBranding,
    useConferenceCall, 
    useRouting, 
    useGlobal, 
    useLogin 
} from '@/composables';

// Define component name
defineOptions({
    name: 'supplementalRegister'
});

// Composables
const { t } = useI18n();

// Initialize composables  
const {
    countries,
    isUserPresenter,
    onUserRegistrationStatus,
    fetchCountries,
} = useLogin();

const {
    conferenceCallDetails,
    isRegistered,
    isPublicParticipantValue,
    uniqueId,
    registerForConferenceCall,
    updateRegisteredParticipantForConferenceCall,
    getRegisteredUserForCall,
} = useConferenceCall();

const {
    disclaimers,
    fetchDisclaimers,
} = usePresentation();

const {
    brandingData,
} = useCorporateBranding();

const { changeUrl } = useRouting();

const { displaySystemMessage } = useGlobal();

// Reactive data
const isValidEmail = ref(true);
const optionalText = ref(Constants.Translation.FormOptionalSuffix);
const publicSelected = ref(null);
const fieldBlurred = reactive({
    callTypeDeclaration: false,
    salesRepName: false,
    ccInvite: false,
    cityLocation: false,
    joinPreference: false,
    dailInLocation: false,
    staffNumber: false
});
const decRules = reactive({
    required: true
});

const registrationFields = reactive({
    CCInvite: {
        data: {},
        tooltip_options: {
            placement: 'top',
            classes: ['info-text'],
            iconClasses: ['input-tooltip-icon'],
            offset: 0,
            delay: {
                show: 600,
                hide: 500,
            },
            content: t(Constants.Translation.SupplementFormFieldToolTip.replace('{formfield}', 'ccinvite')),
        },
        rules: {
            required: false,
            regex: Constants.EmailAddressRegex
        },
        value: '',
    },
    SalesRep: {
        data: {},
        rules: {
            required: false
        },
        value: '',
    },
    CityLocation: {
        data: {},
        tooltip_options: {
            placement: 'top',
            classes: ['info-text'],
            iconClasses: ['input-tooltip-icon'],
            offset: 0,
            delay: {
                show: 600,
                hide: 500,
            },
            content: t(Constants.Translation.SupplementFormFieldToolTip.replace('{formfield}', 'citylocation')),
        },
        rules: {
            required: false
        },
        value: '',
    },
    JoinPreference: {
        data: {},
        options: [],
        rules: {
            required: false
        },
        value: '',
    },
    DailInLocation: {
        data: {},
        tooltip_options: {
            placement: 'top',
            classes: ['info-text'],
            iconClasses: ['input-tooltip-icon'],
            offset: 0,
            delay: {
                show: 600,
                hide: 500,
            },
            content: t(Constants.Translation.SupplementFormFieldToolTip.replace('{formfield}', 'dailinlocation')),
        },
        rules: {
            required: false
        },
        value: '',
    },
    StaffNumber: {
        data: {},
        rules: {
            required: false
        },
        value: '',
    }
});

// Computed properties
const initialFormValues = computed(() => ({
    callTypeDeclaration: publicSelected.value || '',
    salesRepName: registrationFields.SalesRep.value || '',
    ccInvite: registrationFields.CCInvite.value || '',
    cityLocation: registrationFields.CityLocation.value || '',
    joinPreference: registrationFields.JoinPreference.value || '',
    dailInLocation: registrationFields.DailInLocation.value || '',
    staffNumber: registrationFields.StaffNumber.value || ''
}));

const CCInviteValue = computed(() => registrationFields.CCInvite.value);

const isComplete = computed(() => {
    if (isRegistered.value && isRegistered.value.Id) {
        return ((publicSelected.value !== null && conferenceCallDetails.value.AskForPublicPrivate) || !conferenceCallDetails.value.AskForPublicPrivate);
    }
    const CCInviteRequired = getIndex('CCInvite') !== -1 ? brandingData.value.RegistrationFields[getIndex('CCInvite')].Required : false;
    const SalesRepRequired = getIndex('SalesRep') !== -1 ? brandingData.value.RegistrationFields[getIndex('SalesRep')].Required : false;
    const CityLocationRequired = getIndex('CityLocation') !== -1 ? brandingData.value.RegistrationFields[getIndex('CityLocation')].Required : false;
    const JoinPreferenceRequired = getIndex('JoinPreference') !== -1 ? brandingData.value.RegistrationFields[getIndex('JoinPreference')].Required : false;
    const DailInLocationRequired = getIndex('DailInLocation') !== -1 ? brandingData.value.RegistrationFields[getIndex('DailInLocation')].Required : false;
    const StaffNumberRequired = getIndex('StaffNumber') !== -1 ? brandingData.value.RegistrationFields[getIndex('StaffNumber')].Required : false;

    return (!CCInviteRequired || !hasField('CCInvite') || registrationFields.CCInvite.value) &&
        (!SalesRepRequired || !hasField('SalesRep') || registrationFields.SalesRep.value) &&
        (!CityLocationRequired || !hasField('CityLocation') || registrationFields.CityLocation.value) &&
        (!JoinPreferenceRequired || !hasField('JoinPreference') || registrationFields.JoinPreference.value) &&
        (!DailInLocationRequired || !hasField('DailInLocation') || registrationFields.DailInLocation.value) &&
        (!StaffNumberRequired || !hasField('StaffNumber') || registrationFields.StaffNumber.value) &&
        ((publicSelected.value !== null && conferenceCallDetails.value.AskForPublicPrivate) || !conferenceCallDetails.value.AskForPublicPrivate);
});

const hasOptionalFields = computed(() => {
    let res = false;
    if (brandingData.value && brandingData.value.RegistrationFields) {
        brandingData.value.RegistrationFields.forEach(element => {
            if (!element.Required && !element.IsDeleted) {
                res = true;
            }
        });
    }
    return res;
});

const hasFormFields = computed(() => {
    if (isRegistered.value && isRegistered.value.Id) {
        return false;
    }
    var index = -1;
    if (brandingData.value && brandingData.value.RegistrationFields) {
        index = brandingData.value.RegistrationFields.findIndex((val) => {
            return val.Name !== 'AccountType' && val.Name !== 'CompanyRole' && val.Name !== 'PhoneNumber' && !val.IsDeleted;
        });
    }
    return index !== -1;
});

const hasAdditionalIns = computed(() => {
    var additionalInstructionsPresent = -1;
    if (brandingData.value && brandingData.value.CustomMessages) {
        additionalInstructionsPresent = brandingData.value.CustomMessages.findIndex((val) => {
            return val.Key === 'AdditionalInstructions' && val.Value !== '';
        });
    }
    return additionalInstructionsPresent;
});

const invalidDomainMessage = computed(() => {
    return isValidEmail.value ? '' : 'invalid_CCInvite_domain';
});

const registrationPlaceholder = computed(() => {
    let placeholder = registrationLabel.value;
    if (registrationFields.SalesRep.data.Label) {
        placeholder = registrationFields.SalesRep.data.Label;
    }
    return placeholder;
});

const registrationLabel = computed(() => {
    if (!registrationFields.SalesRep.data.Name) {
        return;
    }
    return t(Constants.Translation.SupplementFormFieldLabel.replace('{formfield}', registrationFields.SalesRep.data.Name.toLowerCase()));
});

const ccInvitePlaceholder = computed(() => {
    let placeholder = ccInviteLabel.value;
    if (registrationFields.CCInvite.data.Label) {
        placeholder = registrationFields.CCInvite.data.Label;
    }
    return placeholder;
});

const ccInviteLabel = computed(() => {
    if (!registrationFields.CCInvite.data.Name) {
        return;
    }
    return t(Constants.Translation.SupplementFormFieldLabel.replace('{formfield}', registrationFields.CCInvite.data.Name.toLowerCase()));
});

const ccInviteToolTip = computed(() => {
    const toolTip = registrationFields.CCInvite.tooltip_options;
    toolTip.content = t(Constants.Translation.SupplementFormFieldToolTip.replace('{formfield}', 'ccinvite'));
    return toolTip;
});

const cityLocationPlaceholder = computed(() => {
    let placeholder = cityLocationLabel.value;
    if (registrationFields.CityLocation.data.Label) {
        placeholder = registrationFields.CityLocation.data.Label;
    }
    return placeholder;
});

const cityLocationLabel = computed(() => {
    if (!registrationFields.CityLocation.data.Name) {
        return;
    }
    return t(Constants.Translation.SupplementFormFieldLabel.replace('{formfield}', registrationFields.CityLocation.data.Name.toLowerCase()));
});

const cityLocationToolTip = computed(() => {
    const toolTip = registrationFields.CityLocation.tooltip_options;
    toolTip.content = t(Constants.Translation.SupplementFormFieldToolTip.replace('{formfield}', 'citylocation'));
    return toolTip;
});

const joinPreferencesPlaceholder = computed(() => {
    let placeholder = joinPreferencesLabel.value;
    if (registrationFields.JoinPreference.data.Label) {
        placeholder = registrationFields.JoinPreference.data.Label;
    }
    return placeholder;
});

const joinPreferencesLabel = computed(() => {
    if (!registrationFields.JoinPreference.data.Name) {
        return;
    }
    return t(Constants.Translation.SupplementFormFieldLabel.replace('{formfield}', registrationFields.JoinPreference.data.Name.toLowerCase()));
});

const joinPreferencesOption = computed(() => ([{
    label: 'Online',
    value: t(Constants.Translation.JoinPreferenceOptionOnline)
},
{
    label: 'Phone',
    value: t(Constants.Translation.JoinPreferenceOptionPhone)
},
]));

const dailInLocationPlaceholder = computed(() => {
    let placeholder = dailInLocationLabel.value;
    if (registrationFields.DailInLocation.data.Label) {
        placeholder = registrationFields.DailInLocation.data.Label;
    }
    return placeholder;
});

const dailInLocationLabel = computed(() => {
    if (!registrationFields.DailInLocation.data.Name) {
        return;
    }
    return t(Constants.Translation.SupplementFormFieldLabel.replace('{formfield}', registrationFields.DailInLocation.data.Name.toLowerCase()));
});

const dailInToolTip = computed(() => {
    const toolTip = registrationFields.DailInLocation.tooltip_options;
    toolTip.content = t(Constants.Translation.SupplementFormFieldToolTip.replace('{formfield}', 'dailinlocation'));
    return toolTip;
});

const staffNumberPlaceholder = computed(() => {
    let placeholder = staffNumberLabel.value;
    if (registrationFields.StaffNumber.data.Label) {
        placeholder = registrationFields.StaffNumber.data.Label;
    }
    return placeholder;
});

const staffNumberLabel = computed(() => {
    if (!registrationFields.StaffNumber.data.Name) {
        return;
    }
    return t(Constants.Translation.SupplementFormFieldLabel.replace('{formfield}', registrationFields.StaffNumber.data.Name.toLowerCase()));
});

const isPublicParticipantDeclared = computed(() => {
    return isPublicParticipantValue.value ? isPublicParticipantValue.value : JSON.parse(sessionStorage.getItem('isPublicParticipant'));
});

const continueButtonText = computed(() => {
    if (isRegistered.value && isRegistered.value.Id) {
        return t('login.continue');
    }
    return t('supplemental_register.continue_label');
});

const currentUserIsPresenter = computed(() => {
    return isUserPresenter.value || JSON.parse(sessionStorage.getItem(Constants.SessionStorageKeys.IsPresenter));
});


// Methods
const createMetadata = () => {
    var metadata = {};
    for (var key of Object.keys(registrationFields)) {
        if (!registrationFields[key].data.IsDeleted) {
            metadata[key] = registrationFields[key].value;
        }
    }
    if (metadata['JoinPreference'] && metadata['JoinPreference'].value) {
        metadata['JoinPreference'] = metadata['JoinPreference'].value;
    }
    if (metadata['DailInLocation'] && metadata['DailInLocation'].Name) {
        metadata['DailInLocation'] = metadata['DailInLocation'].Name;
    }
    return metadata;
};

const submitAdditionalDetails = async (values) => {
    // Ensure we're working with form values
    if (!values) {
        values = {};
    }

    if (hasField('CCInvite') && registrationFields.CCInvite.value != '') {
        const isEmailDomainValid = await confirmEmailDomain(registrationFields.CCInvite.value);
        if (!isEmailDomainValid.data) {
            isValidEmail.value = false;
            return;
        }
    }

    const isPublicParticipant =
        publicSelected.value === null ?
            null :
            publicSelected.value === 'true' ?
                true :
                false;

    sessionStorage.setItem(Constants.SessionStorageKeys.IsPublicParticipant, isPublicParticipant);
    sessionStorage.setItem(Constants.SessionStorageKeys.RegistrationFields, JSON.stringify(createMetadata()));
    handleNavigation();
};

const handleNavigation = async () => {
    const navigateTo = (baseRouteName) => {
        const routeName = uniqueId.value ? `${baseRouteName}-new` : baseRouteName;
        changeUrl(routeName);
    };

    // If participant is already registered but declaration is missing then update participant
    if (isRegistered.value && isRegistered.value.Id) {
        await updateRegisteredParticipantForConferenceCall();
        navigateTo('call-confirmation');
        return;
    }

    // Fetch presentation details to check for any disclaimers
    await fetchDisclaimers();

    if (disclaimers.value && disclaimers.value.length > 0) {
        navigateTo('disclaimer');
        return;
    }

    await registerForConferenceCall();
    navigateTo('call-confirmation');
};

const getIndex = (field) => {
    var index = -1;
    if (brandingData.value && brandingData.value.RegistrationFields) {
        index = brandingData.value.RegistrationFields.findIndex((val) => {
            return val.Name !== 'AccountType' && val.Name !== 'CompanyRole' && val.Name !== 'PhoneNumber' && val.Name === field && !val.IsDeleted;
        });
    }
    return index;
};

const hasField = (field) => {
    if (isRegistered.value && isRegistered.value.Id) {
        return false;
    }
    var index = getIndex(field);
    return index !== -1;
};

const setRegistrationFieldsRules = () => {
    registrationFields.CCInvite.rules.required = getIndex('CCInvite') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('CCInvite')].Required : false;
    registrationFields.SalesRep.rules.required = getIndex('SalesRep') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('SalesRep')].Required : false;
    registrationFields.CityLocation.rules.required = getIndex('CityLocation') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('CityLocation')].Required : false;
    registrationFields.JoinPreference.rules.required = getIndex('JoinPreference') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('JoinPreference')].Required : false;
    registrationFields.DailInLocation.rules.required = getIndex('DailInLocation') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('DailInLocation')].Required : false;
    registrationFields.StaffNumber.rules.required = getIndex('StaffNumber') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('StaffNumber')].Required : false;
};

const setRegistrationFields = () => {
    registrationFields.CCInvite.data = getIndex('CCInvite') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('CCInvite')] : {};
    registrationFields.SalesRep.data = getIndex('SalesRep') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('SalesRep')] : {};
    registrationFields.CityLocation.data = getIndex('CityLocation') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('CityLocation')] : {};
    registrationFields.JoinPreference.data = getIndex('JoinPreference') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('JoinPreference')] : {};
    registrationFields.DailInLocation.data = getIndex('DailInLocation') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('DailInLocation')] : {};
    registrationFields.StaffNumber.data = getIndex('StaffNumber') !== -1 ?
        brandingData.value.RegistrationFields[getIndex('StaffNumber')] : {};
};

const getErrorMessage = (field, error) => {
    return t(error, {
        field: field
    });
};

const handleSalesRepChange = (value) => {
    registrationFields.SalesRep.value = value;
};

const handleCCInviteChange = (value) => {
    registrationFields.CCInvite.value = value;
};

const handleCityLocationChange = (value) => {
    registrationFields.CityLocation.value = value;
};

const handleStaffNumberChange = (value) => {
    registrationFields.StaffNumber.value = value;
};

const onJoinPreferenceChange = (value) => {
    registrationFields.JoinPreference.value = value;
};

const onDailInLocationChange = (value) => {
    registrationFields.DailInLocation.value = value;
};

const updateField = (fieldName, value) => {
    // This method helps synchronize vee-validate's form state with component data
    if (fieldName === 'callTypeDeclaration') {
        publicSelected.value = value;
    }
};

// Watchers
watch(CCInviteValue, (newVal) => {
    if (newVal === '') {
        isValidEmail.value = true;
    }
});

// Lifecycle hooks
onBeforeMount(async () => {
    if (!(isRegistered.value && isRegistered.value.Id)) {
        await getRegisteredUserForCall();
    }
    if (sessionStorage.getItem(Constants.SessionStorageKeys.AccountConfirmed)) {
        sessionStorage.removeItem(Constants.SessionStorageKeys.AccountConfirmed);
        displaySystemMessage(Constants.Messages.AccountConfirmation);
    }
    setRegistrationFields();
    setRegistrationFieldsRules();
    fetchCountries();
});

onMounted(() => {
    if (currentUserIsPresenter.value) {
        publicSelected.value = false;
    } else {
        publicSelected.value = isPublicParticipantDeclared.value;
    }
    registrationFields.SalesRep.value = sessionStorage.getItem('salesRepName');
});
</script>

<style lang="stylus" scoped>
@import '~@/shared/styles/common.scss';
@import '~@/shared/styles/formControl.scss';

.input-container {
    position: relative;
}

.form-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    min-height: 350px;
}

.select-label {
    margin-right: 10px;
}

.gutter-bottom-15 {
    margin-bottom: 15px;
}

.gutter-top-20 {
    margin-top: 20px;
}

.heading {
    font-family: 'Lato',
        sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.0994px;
    color: #3a4145;
}

.declaration-heading {
    margin-bottom: 16px;
}

.form-fields-heading {
    margin-bottom: 24px;
}

.width-49 {
    width: 49%;
}

.radio-label {
    display inline-block;
    margin-right: 8px;
}

input[type="radio"] {
    display: none;
}

input[type="radio"]:checked+.radio-div {
    background-color: #F4F5F5;
    color: #3a4145;
    font-weight: 700;
}

.radio-div {
    width: 89px;
    height: 46px;
    background-color: #FFFFFF;
    border: 1px solid #D1D1D1;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.0994px;
    color: #6C6C6C;
    text-transform: uppercase;
    font-family: 'Lato',
        sans-serif;
    display: table;
    text-align: center;
    cursor: pointer;
}

.radio-div>span {
    display: table-cell;
    vertical-align: middle;
}

.private-call-information {
    margin-top: 16px;
    font-size: 14px;
    text-align: left;

    pre {
        white-space: pre-wrap;
    }
}

.container {
    height auto;
}

.supplementalRegisterContainer {
    flex-direction: column;
    width: 70%;

    @media screen and (max-width: 1024px) {
        width: 82%;
    }

    #submitDeclerationButton {
        font-family: 'Lato', sans-serif;
        font-size: 14px;

        @media screen and (max-width: 768px) {
            width: 100%;
        }

        @media only screen and (min-width: 0px) and (max-width: 768px),
        only screen and (min-width: 1024px) and (max-width: 1200px) {
            width: 100%;
        }

        background: var(--primary-color);

        &:disabled {
            opacity: 0.5;
        }
    }

    @media screen and (max-width: 768px) {
        width: auto;
    }
}

.optional-label {
    padding: 5px 0 5px 10px;
    font-size: 11px;
    opacity: 0.5;
    color: #868894;
    text-align: left;
}

.margin-bt-10 {
    margin-bottom: 10px;
}

.button-container {
    flex: 1;

    @media screen and (max-height: 768px) {
        height: auto;
        flex: none;
    }

    align-items: baseline;
}

.align-left {
    text-align: left;
}
</style>